/**
 * 0–10 NPS scale selector for the member feedback survey.
 * @agentic members
 */

import { Button, Group, Stack, Text } from "@mantine/core";

import styles from "./NpsScaleInput.module.css";

type NpsScaleInputProps = {
  value: string | undefined;
  onChange: (value: string) => void;
};

/**
 * Renders 0–10 buttons with Worst / Best labels.
 * @agentic members
 */
export const NpsScaleInput = ({ value, onChange }: NpsScaleInputProps) => (
  <Stack gap="xs">
    <Group justify="space-between" gap="xs">
      <Text size="xs" c="dimmed">
        Worst
      </Text>
      <Text size="xs" c="dimmed">
        Best
      </Text>
    </Group>
    <div
      className={styles.scaleGrid}
      role="group"
      aria-label="Score from 0 to 10"
    >
      {Array.from({ length: 11 }, (_, n) => {
        const code = String(n);
        const selected = value === code;
        return (
          <Button
            key={code}
            className={styles.scaleButton}
            variant={selected ? "filled" : "light"}
            onClick={() => onChange(code)}
            aria-pressed={selected}
            aria-label={`Score ${code}`}
          >
            {code}
          </Button>
        );
      })}
    </div>
    <Text size="xs" c="dimmed" ta="center">
      0 is Worst, 10 is Best
    </Text>
  </Stack>
);
